import { combineReducers, Reducer } from '@reduxjs/toolkit';
import authReducer from './features/auth/authSlice'; // Import your auth reducer
import type { AuthState } from './features/auth/authSlice'; // Import your auth state type
import { ClientState } from './features/clients/clientSlice';
import clientReducer from './features/clients/clientSlice';
import customerReducer from './features/customers/customerSlice';
import deficiencyReducer from './features/deficiencies/deficiencySlice';
import { CustomerState } from './features/customers/customerSlice';
import { ContractState } from './features/contracts/contractSlice';
import contractReducer from './features/contracts/contractSlice';
import { EquipmentState } from './features/equipments/equipmentSlice';
import equipmentReducer from './features/equipments/equipmentSlice';
import { ContractDetailsState } from './features/contractDetails/contractDetailSlice';
import contractDetailsReducer from './features/contractDetails/contractDetailSlice';
import uiReducer, { UIState } from './features/ui/uiSlice';
import { InsuranceDetailsState } from '@/utils/types';
import insuranceDetailsReducer from './features/insuranceDetails/insuranceDetailsSlice';
import { NotesState } from './features/notes/notesSlice';
import notesReducer from './features/notes/notesSlice';
import { DeficiencyState } from './features/deficiencies/deficiencySlice';
import { PolicyBillingState } from './features/policyBilling/policySlice';
import policyBillingReducer from './features/policyBilling/policySlice';

// Define root state type
export interface RootState {
  auth: Reducer<AuthState>;
  clients: Reducer<ClientState>;
  customers: Reducer<CustomerState>;
  contracts: Reducer<ContractState>;
  equipments: Reducer<EquipmentState>;
  contractDetails: Reducer<ContractDetailsState>;
  ui: Reducer<UIState>;
  insuranceDetails: Reducer<InsuranceDetailsState>;
  notes: Reducer<NotesState>;
  deficiencies: Reducer<DeficiencyState>;
  policyBilling: Reducer<PolicyBillingState>;
  // Add other state interfaces here
}

const rootReducer = combineReducers<RootState>({
  auth: authReducer,
  clients: clientReducer,
  customers: customerReducer,
  contracts: contractReducer,
  equipments: equipmentReducer,
  contractDetails: contractDetailsReducer,
  ui: uiReducer,
  insuranceDetails: insuranceDetailsReducer,
  notes: notesReducer,
  deficiencies: deficiencyReducer,
  policyBilling: policyBillingReducer,
  // Add other reducers here
});

export default rootReducer;
